import { createElement, FC } from "react";
import { LoadingIndicator } from "../../../LoadingIndicator";
import { useTableContext, useTablePropsContext } from "../../context";

import styles from "./styles.module.scss";

export type TableOverlayProps = {
  isFetching: boolean,
  bodyHeight: number,
  headerHeight: number
}

//todo fix rerender on silence data change
export const TableOverlay: FC<TableOverlayProps> = (({ isFetching, bodyHeight, headerHeight }) => {
  const table = useTableContext();
  const { emptyPlaceholderComponent } = useTablePropsContext();

  const noRecordsFound = !isFetching && !table.getRowModel().rows.length;
  const showOverlay = (isFetching || noRecordsFound);

  if (!showOverlay) {
    return null;
  }

  return (
    <div
      className={styles.overlay}
      style={{
        top: noRecordsFound ? 0 : headerHeight,
        height: noRecordsFound ? bodyHeight + headerHeight : bodyHeight,
      }}
    >
      {isFetching && <LoadingIndicator />}
      {
        noRecordsFound &&
        createElement(emptyPlaceholderComponent!)
      }
    </div>
  );
});